import { aludraApi } from 'Api/axios'

const mdl11 = {
  fetchLinkedProductVariants: '/mdl22/variants/linkproductvariant/search',
  fetchProductVariantFilter: '/mdl22/variants/productvariantfilter/search',
}

/**
 * Service that allows searching for products within the tinting options.
 * The search for products within tinting options is different from the general product search.
 *
 * @param {Object} payload - Data sent in the request.
 * @param {string} [payload.code] - ProductId or SKU of the product. If not provided, the search will be done without this filter.
 * @param {string} payload.searchText - Text to search within the tinting options.
 * @param {number} payload.pageSize - Number of records per page.
 * @param {number} payload.pageNumber - The page number to retrieve.
 * @returns {Promise<Object>} - Returns the backend response with the products matching the filters.
 */
export const fetchLinkedProductVariantsService = async (payload = {}) => {
  const defaultPagination = {
    PageNumber: 1,
    PageSize: 10,
  }

  const requestBody = {
    ...defaultPagination,
    ...payload,
  }

  const { data } = await aludraApi.post(
    mdl11.fetchLinkedProductVariants,
    requestBody
  )
  return data
}

/**
 * Service that retrieves a product with the final tinting.
 * Final tinting includes details about line, finish, brand, and presentation of the product.
 *
 * @param {UUID} variantDetailId - Unique identifier for the color variant.
 * @param {number} [payload.pageSize=10] - Number of records per page.
 * @param {number} [payload.pageNumber=1] - The page number to retrieve.
 * @param {string} [payload.Acabado] - Filter by the product finish (optional).
 * @param {string} [payload.Línea] - Filter by the product line (optional).
 * @param {string} [payload.Presentación] - Filter by the product presentation (optional).
 * @param {string} [payload.Marca] - Filter by the product brand (optional).
 * @returns {Promise<Object>} - Returns the product with the final tinting details.
 */
export const fetchProductVariantFilterService = async variantDetailId => {
  if (!variantDetailId) return null

  const requestBody = {
    PageNumber: 1,
    PageSize: 10,
    VariantDetailId: variantDetailId,
  }

  const { data } = await aludraApi.post(
    mdl11.fetchProductVariantFilter,
    requestBody
  )
  return data
}
